const Archiv = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_5085_22059)">
        <path
          d="M5.14648 4.08485V3.03398C5.14648 2.92353 5.23603 2.83398 5.34648 2.83398H10.6534C10.7638 2.83398 10.8534 2.92353 10.8534 3.03398V4.08485"
          stroke="#333333"
          strokeWidth="0.6"
        />
        <path
          d="M4.33008 5.33485V4.28398C4.33008 4.17353 4.41962 4.08398 4.53008 4.08398H11.4675C11.5779 4.08398 11.6675 4.17353 11.6675 4.28398V5.33485"
          stroke="#333333"
          strokeWidth="0.6"
        />
        <path
          d="M5.5459 6.70312C5.70365 6.70324 5.85071 6.77755 5.94434 6.90137L5.98047 6.95703L6.54395 7.9541H9.9707L10.5332 6.95703L10.5703 6.90137C10.6639 6.77754 10.811 6.70327 10.9688 6.70312H13.5059C13.7819 6.70319 14.0059 6.92702 14.0059 7.20312V13.4746C14.0056 13.7505 13.7818 13.9745 13.5059 13.9746H2.49219C2.21624 13.9745 1.9924 13.7505 1.99219 13.4746V7.20312C1.99219 6.92703 2.21611 6.7032 2.49219 6.70312H5.5459Z"
          fill="#333333"
        />
        <path
          d="M5.4668 10.5C5.4668 10.2239 5.69065 10 5.9668 10H10.4996C10.7757 10 10.9996 10.2239 10.9996 10.5C10.9996 10.7761 10.7757 11 10.4996 11H5.9668C5.69065 11 5.4668 10.7761 5.4668 10.5Z"
          fill="white"
        />
        <path
          d="M3.51562 7.00376V5.53594C3.51562 5.42548 3.60517 5.33594 3.71562 5.33594H12.2836C12.394 5.33594 12.4836 5.42548 12.4836 5.53594V7.00376"
          stroke="#333333"
          strokeWidth="0.6"
        />
      </g>
      <defs>
        <clipPath id="clip0_5085_22059">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Archiv;
